'use client';

import type { MentionEntity } from '@terra/shared-dto-chat-types';
import { resolveMentionEntityIcon } from './mentionEntityIcons';

export const MENTION_MENU_ICON_SIZE = 12;

type MentionEntityMenuIconProps = {
  entityType: MentionEntity['entityType'];
  size?: number;
};

export function MentionEntityMenuIcon({
  entityType,
  size = MENTION_MENU_ICON_SIZE,
}: MentionEntityMenuIconProps) {
  const Icon = resolveMentionEntityIcon({ entityType });
  if (!Icon) {
    return null;
  }
  return <Icon size={size} />;
}
